export { default } from './InlinePageTextArea';
export * from './InlinePageTextArea';
